// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"459eef65","855":"ff98ef17"}[chunkId] + ".chunk.js";
};